export default "__VITE_ASSET__DnLezxt2__"